<template>
  <div class="economic-entities">
    <div class="title">
      <span>经济主体</span>
      <ElementSelect :val="yearE" v-model="yearE" :options="eYearList" />
    </div>
    <div class="chart-con">
      <div class="item" v-for="(item, i) in dataList" :key="i">
        <div class="img"></div>
        <div class="detail">
          <div class="name">
            {{ item.name }}
          </div>
          <div class="num">
            {{ item.num ? item.num : '-' }}
            <span class="unit">{{ item.unit }}</span>
          </div>
        </div>
        <div class="ratio-box">
          <div :class="['icon', { up: item.ratio && item.ratio > 0, down: item.ratio && item.ratio < 0 }]"></div>
          <span>同比</span>
          <span :class="{ up: item.ratio && item.ratio > 0, down: item.ratio && item.ratio < 0 }">
            {{ item.ratio && item.ratio >= 0 ? '+' : '' }}{{ item.ratio !== null ? item.ratio : '-'
            }}{{ item.ratio !== null ? '%' : '' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ElementSelect from '../../../components/element-select';
export default {
  name: 'EconomicEntities',
  components: { ElementSelect },
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
    selectListP: {
      // 列信息
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      yearE: 0,
      year: this.yearP,
      eYearList: [],
      eYearOption: [],
      selectList: [...this.selectListP],
      // [
      // {
      //   value: 2022,
      //   label: 2022
      // },
      // {
      //   value: 2021,
      //   label: 2021
      // },
      // ],
      dataList: [
        {
          name: '全国经济主体',
          num: 1.54,
          unit: '亿',
          ratio: 11.1,
        },
        {
          name: '全省经济主体',
          num: 1526.44,
          unit: '万',
          ratio: 10.22,
        },
        {
          name: '全省非公经济主体',
          num: 1427.5,
          unit: '万',
          ratio: 4.5,
        },
      ],
    };
  },
  created() {
    this.initYear();
  },
  watch: {
    yearE(n) {
      this.getData();
    },
  },
  methods: {
    initYear(){
      this.$api.market.getTyYearOption({dataType: 'tj_economic_subject'}).then((res) => {
        this.eYearOption = res.data.data.data;
        // console.log("yearE", this.yearE)
        if (this.yearE === 0) {
          this.yearE = this.eYearOption[0];
          this.eYearList = []
          for (let key in this.eYearOption) {
            this.eYearList.push(
                    {
                      value: this.eYearOption[key],
                      lable: this.eYearOption[key],
                    }
            );
          }
          // console.log("this.eYearList",this.eYearList)
        }
      });

    },
    getData() {
      this.$api.screen
        .getEconomicSubject({
          year: this.yearE,
        })
        .then((res) => {
          let { data } = res.data;
          console.log(this.yearE, res.data);
          if (data?.length) {
            this.dataList = data.map((item) => {
              return {
                name: item.economicSubjectName,
                num: item.quantity,
                unit: item.quantityUnit,
                ratio: item.yearOnYear,
              };
            });
          } else {
            // this.selectList = this.selectList.filter((x) => x.value !== this.yearE);
            // this.yearE = this.selectList[0].value;
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.economic-entities {
  .chart-box();

  .chart-con {
    .item {
      margin-top: 5px;
      /*margin: 10px 0;*/
      .flex-center();
    }

    .img {
      min-width: 136px;
      height: 72px;
      background: url('~img/home/economic-icon.png') no-repeat;
      background-size: 100% 100%;
      margin-bottom: 10px;
    }

    .detail {
      width: 160px;
      color: #fff;
      margin: 0 20px;

      .name {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #eff0f1;
        line-height: 29px;
        position: relative;
        word-break: keep-all;

        &::before {
          content: '';
          width: 211px;
          height: 14px;
          background: linear-gradient(90deg, rgba(0, 181, 237, 0.65), rgba(0, 0, 0, 0) 50%);
          position: absolute;
          left: -23px;
          bottom: -1px;
          z-index: -1;
          transform: skew(-35deg);
        }
      }

      .num {
        font-size: 24px;
        font-family: Geometr706 BlkCn BT;
        font-weight: 900;
        color: #6acbff;
        line-height: 38px;
        margin-top: 5px;

        .unit {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #eff0f1;
          line-height: 29px;
          opacity: 0.6;
          /*margin-left: 10px;*/
        }
      }
    }

    .ratio-box {
      .flex-center();
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 38px;

      .icon {
        width: 16px;
        height: 16px;
        background-size: 100% 100% !important;
        margin-right: 10px;

        &.up {
          background: url('~img/home/economic-up.png') no-repeat;
        }

        &.down {
          background: url('~img/home/economic-down.png') no-repeat;
        }
      }

      span {
        margin-right: 20px;
        word-break: keep-all;

        &:last-child {
          min-width: 80px;
          .flex-center();
        }
      }

      .up {
        color: #ff6a6a;
      }

      .down {
        color: #58ecac;
      }
    }
  }
}
</style>
